<template>
  <div class="set-goal-config">
    <el-form ref="formRef" label-width="100" :model="formData" :rules="rules">
      <el-form-item label="目标年份：" prop="year">
        <el-date-picker
          style="width: 660px"
          v-model="formData.year"
          type="year"
          placeholder="请选择年份"
          value-format="yyyy"
          :picker-options="pickerOptions"
        />
      </el-form-item>
      <el-form-item label="员工姓名：" prop="employeeList">
        <CustomSearchSelect
          style="width: 660px"
          v-model="formData.employeeList"
          :options="employeeOptions"
          placeholder="请选择员工"
          searchPlaceholder="请输入员工姓名搜索"
        ></CustomSearchSelect>
      </el-form-item>
      <el-form-item label="引入目标：" prop="goalTableData">
        <el-table :data="formData.goalTableData" border stripe max-height="500px">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="avgStar" label="星级" min-width="60"></el-table-column>
          <el-table-column label="周期" min-width="150">
            <template #default="{ row }">
              <el-form-item
                label=""
                :prop="'goalTableData.' + row.index + '.period'"
                :rules="[
                  { required: true, message: '请选择周期', trigger: 'change' }
                ]"
              >
                <el-radio-group v-model="row.period">
                  <el-radio label="1">每年</el-radio>
                  <el-radio label="2">季度</el-radio>
                  <el-radio label="3">每月</el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="目标数量" min-width="150">
            <template #default="{ row }">
              <el-form-item
                label=""
                :prop="'goalTableData.' + row.index + '.goalNum'"
                :rules="[
                  { required: true, message: '请输入数量', trigger: 'change' }
                ]"
              >
                <el-input
                  style="width: 100%"
                  v-model="row.goalNum"
                  placeholder="请输入"
                  clearable
                >
                  <template #append>个</template>
                </el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="生效时间：">
        <div style="color: #000">次月生效</div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request'
const tableColumns = [
  { label: '序号', type: 'index' },
  { label: '星级', prop: 'avgStar' },
  { label: '周期', slotName: 'period'},
  { label: '目标数量', prop: 'goalNum'},
]
const initFormData = () => ({
  year: '',
  employeeList: [],
  tableColumns,
  goalTableData: [
    {
      index: 0,
      props: 'name',
      avgStar: '五星',
      starNum: '5',
      period: '1',
      goalNum: ''
    },
    {
      index: 1,
      props: 'name',
      avgStar: '四星',
      starNum: '4',
      period: '2',
      goalNum: ''
    },
    {
      index: 2,
      props: 'name',
      avgStar: '三星',
      starNum: '3',
      period: '3',
      goalNum: ''
    }
  ]
})
export default {
  name: 'SetGoalConfig',
  data() {
    return {
      formData: initFormData(),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() // 禁用今天之前的日期
        }
      },
      employeeOptions: [],
      rules: {
        year: [
          { required: true, message: '请选择目标年份', trigger: 'change' }
        ],
        employeeList: [
          { required: true, message: '请选择员工', trigger: 'input' }
        ],
        goalTableData: [
          { required: true, message: '请选择', trigger: 'change' }
        ]
      },
      disabledDate(time) {
        return new Date(time).getFullYear() < new Date().getFullYear()
      },
      checkAll: false
    }
  },
  methods: {
    async getEmployeeOptions() {
      const params = {}
      try {
        const res = await request.get('/cluepool/pc/user/all', params, '')
        if(res.code === 200) {
          this.employeeOptions = (res.data || []).map(item => ({
            label: item.nickName,
            value: item.workNumber
          }))
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('请求员工列表数据请求失败', error)
      }
    }
  },
  created() {
    this.getEmployeeOptions()
  },
  components: {
    CustomSearchSelect: () => import('@/views/DoctorVisitLTC/components/customSearchSelect/Custom_Search_Select.vue')
  },
  watch: {
    'formData.employeeList'(val){
      console.log(val)
    }
  }
}
</script>

<style scoped lang="less">
.set-goal-config {
  .tips {
    margin-top: 30px;
    font-size: 14px;
    color: #000;
    font-weight: 600;
  }
}

</style>
